import React from 'react';
import helper from 'components/utils/helper';
import { Container, Bar, Language, Close } from './LanguageBar.style';

import ConfigContext from 'context/ConfigContext';

const LanguageBar = () => {
    let configContext = React.useContext(ConfigContext);
    let config = configContext.config;

    const [isActive, setIsActive] = React.useState(false);
    let {country, language} = helper.getUrlLocale();

    React.useEffect(() => {
        // let languageBarDisabled = document.cookie.split(';').some(item => item.trim().indexOf('language-bar-is-disabled') === 0);
        let languageBarDisabled = helper.getCookie('language-bar-is-disabled');
        let hasMultipleLanguages = config.getValue(["locale", country, "language"]) && config.getValue(["locale", country, "language"]).length > 1;
        if (!languageBarDisabled && hasMultipleLanguages){
            setIsActive(true);
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onSelectLanguage(code) {
        if(code === 'en' && language !== 'en') {
            window.location = '/'
        } else if(code !== 'en' && code !== language){
            window.location = `/${code}/`;
        }
        setIsActive(false);
        helper.setCookie('language-bar-is-disabled', 'true', 30);
    }

    return ( 
        <Container isVisible={isActive}>
            <Bar>
                {config.getValue(["locale",country, "language"]) && config.getValue(["locale",country, "language"]).map((lang, index) =>
                    <Language key={index} 
                        isSelected={config.getLanguage() === lang.code}
                        onClick={() => onSelectLanguage(lang.code)}>
                            {lang.name}
                    </Language>
                )}
                <Close onClick={() => setIsActive(false)}/>
            </Bar>
        </Container>
    );
}
 
export default LanguageBar;